module.exports = __webpack_public_path__ + "img/open_order_2.c4fa1a95.png";